var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MappedImage } from "@tk-events/fw";
import podcastHub from "../modal/podcastHub";
import recentReleases from "../modal/recentReleases";
import riskManagement from "../modal/riskManagement";
import peopleManagement from "../modal/peopleManagement";
import complianceGovernance from "../modal/complianceGovernance";
import { benchmarksLinks, futureResearch, iramT, isfServices, magazineRackLeft, magazineRackR, qiraLinks, SOGP, supplierSec, ThreadHorizon } from "../modal/explorationVideos";
import { textModal } from "../booths/common";
import React from "react";
import { getUserData } from "../../../config/common";
var ImageModal = function (content, closeTop, closeRight) {
    if (closeTop === void 0) { closeTop = null; }
    if (closeRight === void 0) { closeRight = null; }
    return ({
        modalOverrides: {
            dismissHTML: " ",
            dismissStyle: {
                color: "#fff",
                fontSize: "25px",
                top: closeTop || "4%",
                right: closeRight || "17.1%",
                width: "2%",
                height: "4%"
            }
        },
        modal: content
    });
};
var listenHere = __assign({ width: "5.8%", height: "18.1%", left: "64%", top: "51.8%", label: "Discover the ISF Podcast library" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2138562-63500c547ff84.png", links: podcastHub })));
var risk = __assign({ width: "8.8%", height: "25.1%", left: "59.1%", top: "36%", label: "Risk - Access ISF research and further information", hoverMessage: "Access ISF research and further information" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2138892-63501b563c010.png", links: riskManagement }), "6%", "20.4%"));
var recent = __assign({ width: "8.8%", height: "25.1%", left: "32.1%", top: "36%", hoverMessage: "Access the latest ISF research", label: "Access the latest ISF research" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2138945-63501da029f8e.png", links: recentReleases }), "6%", "20.4%"));
var management = __assign(__assign({}, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2141163-6350587c95cd1.png", links: peopleManagement }), "6%", "20.4%")), { width: "8.8%", height: "25.1%", left: "41.1%", top: "36%", label: "Access ISF research and further information", hoverMessage: "Access ISF research and further information" });
var compliance = __assign(__assign({}, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2144241-63519bb1822bb.png", links: complianceGovernance }), "6%", "20.4%")), { width: "8.8%", height: "25.1%", left: "50.1%", top: "36%", hoverMessage: "Access key information related to your ISF Membership", label: "Access key information related to your ISF Membership" });
var services = __assign({ width: "12.4%", height: "15.1%", left: "69.1%", top: "37.7%", label: "See the suite of ISF Services avaliable to organisations " }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2144284-63519edecd3e3.png", links: isfServices }), "21.5%", "29%"));
var benchmarks = __assign({ width: "17%", height: "20.1%", left: "1.1%", top: "15.7%", label: "Discover how Benchmark can assess your current security status" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2144645-6351ae44d04a8.png", links: benchmarksLinks }), "13.5%", "21.7%"));
var future = __assign({ width: "12.6%", height: "16.1%", left: "68.8%", top: "20.7%", label: "Got a core topic you'd like us to research? Submit your ideas through the Future Research Hub" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2145006-6351cb5b9742f.png", links: futureResearch }), "13.5%", "21.7%"));
var QIRA = __assign({ width: "17%", height: "18.1%", left: "81.8%", top: "16.7%", label: "Dicover how the QIRA product suite can help you quantify risk" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2182962-636aad7b2af55.png", links: qiraLinks }), "13.5%", "21.7%"));
var iramtwo = __assign({ width: "12.6%", height: "16.1%", left: "18.3%", top: "20.7%", label: "Discover how the IRAM2 methodology can help you conduct risk assessments" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2182961-636aad7a1f225.png", links: iramT }), "13.5%", "21.7%"));
var supplier = __assign({ width: "12.6%", height: "15.1%", left: "18.3%", top: "37.7%", label: "Discover how Supply Security can help you track existing supplier relationships" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2182965-636aad7cbcbc8.png", links: supplierSec }), "13.5%", "21.7%"));
var sogp = __assign({ width: "16.6%", height: "18.1%", left: "1.3%", top: "36.7%", label: "Discover how the Standard of Good Practice framework can support your organisation" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2182964-636aad7bd8b1c.png", links: SOGP }), "13.5%", "21.7%"));
var threadHorizon = __assign({ width: "16.7%", height: "17.1%", left: "82%", top: "36.7%", label: "Learn about our plans for Threat Horizon this year, and what the future holds for our flagship research" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2145085-6351d260cef6e.png", links: ThreadHorizon }), "13.5%", "21.7%"));
var leftMagazineRack = __assign({ width: "5.8%", height: "29.1%", left: "11.3%", top: "54.7%", label: "Find out more about the services included in your ISF Membership" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2165167-63600a39342fd.png", links: magazineRackLeft }), "14.6%", "26.8%"));
var rightMagazineRack = __assign({ width: "5.8%", height: "29.1%", left: "82.8%", top: "54.7%", label: "The latest cyber security trends and how the ISF can help" }, ImageModal(React.createElement(MappedImage, { roomName: "ExplorationZone", imageURL: "https://assets.swoogo.com/uploads/full/2154680-6358452466165.png", links: magazineRackR }), "11%", "29%"));
var tellUs = {
    width: "4.8%",
    height: "17.1%",
    left: "31.6%",
    top: "52%",
    label: "Let us know what is important to you with this quick survey",
    modalOverrides: textModal("fit-content"),
    modal: React.createElement("h1", null, "The surveys are now closed.")
};
var chatWithUs = {
    width: "7.8%",
    height: "23.1%",
    left: "46.6%",
    top: "60%",
    label: "Have a question about ISF research, products or services? Talk to us here",
    isExternal: false,
    modalOverrides: textModal("fit-content"),
    modal: React.createElement("h1", null, "The chat feature is now closed.")
};
export var body = {
    userData: getUserData(),
    background: "https://assets.swoogo.com/uploads/full/2178460-636911afbf470.jpg",
    name: "Exploration Zone",
    links: [
        recent,
        risk,
        compliance,
        management,
        listenHere,
        services,
        benchmarks,
        future,
        QIRA,
        iramtwo,
        supplier,
        sogp,
        threadHorizon,
        leftMagazineRack,
        rightMagazineRack,
        tellUs,
        chatWithUs,
        {
            width: "8.2%",
            height: "15.7%",
            left: "46%",
            top: "82.6%",
            label: "Back to Atrium",
            href: "/Atrium"
        }
    ]
};
export var location = "/Exploration-Zone";
